<style scoped>
  .title{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 66px;padding: 0 24px;}
  .title div{width: 4px;height: 18px;background-color: #00a2e9;display: inline-block;margin-right: 5px;vertical-align: text-bottom;}
  .time{display: inline-block;float: right;line-height: 66px;padding: 0 24px;}
  .financial >>> .ivu-input{border-radius: 18px;}
  .search >>> .ivu-input{width: 160px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .search-button{background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 20px;text-align: center;right: 6px;cursor:pointer;}
  .btn-default{font-size: 14px;color: #00a2e9;display: inline-block;vertical-align:middle}
  .list-panel{background-color: white;padding:0 40px}
  .notice-background{background: url("/img/sys/bg3.png");height: 140px;}
  .project{text-align: center;font-size: 14px;color: #333333;height: 62px;border-bottom: 1px solid #d7dde4;line-height: 62px;background-color: #fff;}
</style>

<template>
  <div class="financial">
    <Row style="margin-bottom:15px">
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row :gutter="40">
      <!--今日统计-->
      <Col span="12" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">今日统计</p>
          </div>
          <div class="time">
            <DatePicker type="date" placeholder="选择时间" style="width: 200px"></DatePicker>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;">
            <!--for-->
            <Col span="12" style="margin: 30px 0;">
              <p style="color: #f64b4b;font-size: 24px;">2800</p>
              <p style="color: #464c5b;font-size: 14px;">提成金额</p>
            </Col>
						<Col span="12" style="margin: 30px 0;">
						  <p style="color: #f64b4b;font-size: 24px;">800</p>
						  <p style="color: #464c5b;font-size: 14px;">推荐提成</p>
						</Col>
						<Col span="12" style="margin: 30px 0;">
						  <p style="color: #f64b4b;font-size: 24px;">12300</p>
						  <p style="color: #464c5b;font-size: 14px;">今日到账</p>
						</Col>
						<Col span="12" style="margin: 30px 0;">
						  <p style="color: #f64b4b;font-size: 24px;">38000</p>
						  <p style="color: #464c5b;font-size: 14px;">今日签约</p>
						</Col>
          </Col>
        </div>
      </Col>
      <!--年度统计-->
      <Col span="12" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">年度统计</p>
          </div>
          <div class="time">
            <DatePicker type="daterange" placeholder="选择时间" style="width: 200px"></DatePicker>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;">
            <!--for-->
            <Col span="12" style="margin: 30px 0;" v-for="i in 4">
              <p style="color: #f64b4b;font-size: 24px;">26</p>
              <p style="color: #464c5b;font-size: 14px;">签约总额</p>
            </Col>
          </Col>
        </div>
      </Col>
      <!--未结统计-->
      <Col span="12" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">未结统计</p>
          </div>
          <div class="time">
            <DatePicker type="date" placeholder="选择时间" style="width: 200px"></DatePicker>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;">
            <!--for-->
            <Col span="12" style="margin: 30px 0;" v-for="i in 4">
              <p style="color: #f64b4b;font-size: 24px;">26</p>
              <p style="color: #464c5b;font-size: 14px;">应收总额</p>
            </Col>
          </Col>
        </div>
      </Col>
      <!--年度统计-->
      <Col span="12" style="margin-bottom: 40px;">
        <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
          <div class="title">
            <div class="inline-block"></div>
            <p style="display: inline-block;vertical-align: top;">年度统计</p>
          </div>
          <div class="time">
            <DatePicker type="daterange" placeholder="选择时间" style="width: 200px"></DatePicker>
            <div style="position: relative;display: inline-block;margin-left: 12px;">
              <Input class="search"  placeholder="输入客户名" ></Input>
              <div class="search-button">
                <img style="margin-top: 6px;vertical-align: top;" src="/img/project/search-icon.png"/>
              </div>
            </div>
          </div>
          <Col span="24" style="text-align: center;background-color: #fff;">
            <!--for-->
            <Col span="12" style="margin: 30px 0;" v-for="i in 4">
              <p style="color: #f64b4b;font-size: 24px;">26</p>
              <p style="color: #464c5b;font-size: 14px;">签约总额</p>
            </Col>
          </Col>
        </div>
      </Col>

    </Row>
    <Row>
      <Col span="24"><img style="width:1200px;height:auto" src="/img/date/收入构成.png"></Col>
      <Col span="24"><img style="width:1200px;height:auto" src="/img/date/收入走势.png"></Col>
    </Row>
    <!--数据查询-->
      <Row>
        <Col span="24">
          <div style="border-bottom: 1px solid #d7dde4;height: 66px;background-color: #fff;padding: 0;">
            <div class="title">
              <div class="inline-block"></div>
              <p style="display: inline-block;vertical-align: top;">数据查询</p>
            </div>
            <div style="float: right;display: inline-block;line-height: 66px;margin-right: 40px;">
              <img style="margin: 0 10px;vertical-align:middle" src="/img/project/screen-icon.png"/>
              <p style="color: #6c767a" class="btn-default">筛选</p>
            </div>
          </div>
        </Col>
      </Row>
        <!---->
    <div class="list-panel">
      <Row>
        <Col span="24"  class="project" style="font-weight: bold;">
          <Col span="6">项目名</Col>
          <Col span="3">签约金额</Col>
          <Col span="3">到账金额</Col>
          <Col span="3">待开票金额</Col>
          <Col span="3">开票未付额</Col>
          <Col span="3">已提取金额</Col>
          <Col span="3">可提取金额</Col>
        </Col>
        <Col span="24" class="project" v-for="i in 5">
          <Col span="6">项目名称项目名称项目名称项目名称</Col>
          <Col span="3">1000</Col>
          <Col span="3">1000</Col>
          <Col span="3">1000</Col>
          <Col span="3">1000</Col>
          <Col span="3">1000</Col>
          <Col span="3">1000</Col>
        </Col>
      </Row>
      <Row>
        <Col span="24" style="margin:40px 0 57px 0;">
          <Page :total="100" show-elevator />
        </Col>
      </Row>
    </div>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "financial",//资金统计
  }
</script>

